import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 
/**
* @class MobileDevice
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.mobileDevice[0];
* const device = new MobileDevice(record);
* @property {NUMBER} _id - The id of the MobileDevice
* @property {STRING} _name - The name of the device
* @property {BOOLEAN} _isEnrolled - enrollment status of the device
* @property {BOOLEAN} _recentlyEnrolled - recent enrollment status of the device
* @property {bcmsDate} _enrolledDate - number of days in the past device was enrolled
* @property {STRING} _number - phone number for device
* @property {STRING} _userID - userID for device
* @property {STRING} _password - phone number for device
*/
export default class MobileDevice extends BCMSRecord{
    _id
    _name 
    _nickname
    _isEnrolled
    _recentlyEnrolled
    _enrolledDate
    _number
    _userID
    _password
    
    constructor (record){     
      super( record  ) 
    }
  }
MobileDevice.define({
    "recordType":"mobileDevices",
    "recordIDProp":"id",
    "className" : "MobileDevice",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the device
         * @property set {NUMBER} - sets the id of the device
         * @memberof MobileDevice 
         */
        BCMSRecordProperty.mapToNumber("id", "_id", "id"),
        /** 
         * @name name
         * @instance
         * @property get {STRING} - gets the name of the device
         * @property set {STRING} - sets the name of the device
         * @memberof MobileDevice 
         */
        BCMSRecordProperty.mapToString("name", "_name", "name"),

        /** 
         * @name isEnrolled
         * @instance
         * @property get {STRING} - gets the enrollment status of the device
         * @property set {STRING} - sets the enrollment status of the device
         * @memberof MobileDevice 
         */
        BCMSRecordProperty.mapToBoolean("isEnrolled", "_isEnrolled", "isEnrolled"),

        /** 
         * @name recentlyEnrolled
         * @instance
         * @property get {BOOLEAN} - gets the recent enrollment status
         * @property set {BOOLEAN} - sets the recent enrollment status
         * @memberof MobileDevice 
         */
        BCMSRecordProperty.mapToBoolean("recentlyEnrolled", "_recentlyEnrolled", "recentlyEnrolled"),

        /** 
         * @name enrolledDate
         * @instance
         * @property get {bcmsDate} - gets the enrolledDate of the device
         * @property set {bcmsDate} - sets the enrolledDate of the device
         * @memberof MobileDevice 
         */
        BCMSRecordProperty.mapToDate("enrolledDate", "_enrolledDate", "enrolledDate"),
        /** 
         * @name number
         * @instance
         * @property get {STRING} - gets the number of the device
         * @property set {STRING} - sets the number of the device
         * @memberof MobileDevice 
         */      
        BCMSRecordProperty.mapToString("number", "_number", "number"),

        /** 
         * @name userID
         * @instance
         * @property get {STRING} - gets the userID of the device
         * @property set {STRING} - sets the userID of the device
         * @memberof MobileDevice 
         */      
        BCMSRecordProperty.mapToString("userID", "_userID", "userID"),

        /** 
         * @name password
         * @instance
         * @property get {STRING} - gets the password of the device
         * @property set {STRING} - sets the password of the device
         * @memberof MobileDevice 
         */      
        BCMSRecordProperty.mapToString("password", "_password", "password")
      ]
})




